export default [

     {
          path: '/emergency-scenario',
          name: 'EmergencyScenario',
          component: () => import("@/views/Page/EmergencyScenario/EmergencyScenario.vue"),
           meta: {
               title: 'EmergencyScenario',
          },
     }
];